import React, { useEffect, useState } from 'react'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import * as AlertActions from 'redux/actions/Applications/Alert'
import * as DataProductActions from 'redux/actions/Applications/DataProducts'

import PageHeader from 'components/common/PageHeader/v2'

import ManageDatasetModal from 'components/containers/Applications/DataProducts/ManageDatasetModal'

import EditName from 'components/containers/Applications/DataProducts/modals/EditName'

import Box from 'components_new/atoms/Box'

import Connection from './Connection'
import Dataset from './Dataset'

import {
  getMetaInformation,
  toggleItems,
  getActions
} from 'helpers/Functions/DataProducts'
import { useAccounts } from 'redux/hooks/Accounts'

const SpecificAPI = ({
  match,
  history,
  AppsDataProductStore,
  setAlert,
  resetAlert,
  tryDeleteDataProduct,
  tryUpdateDataProduct,
  location
}) => {
  const [activeToggle, setActiveToggle] = useState('connection')
  const [editName, setEditName] = useState(false)
  const { accountBody } = useAccounts()

  const dataProduct = AppsDataProductStore.data[match.params.id]

  useEffect(() => {
    const pathList = location.pathname.split('/')

    setActiveToggle(pathList[3])
  }, [location])

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <Box sx={{ width: '100%' }}>
        <PageHeader
          header={dataProduct.attributes.name}
          meta={getMetaInformation(dataProduct, accountBody)}
          toggleItems={toggleItems(
            history,
            match.params.id,
            setActiveToggle,
            'API'
          )}
          activeToggle={activeToggle}
          actions={getActions(
            setAlert,
            resetAlert,
            () => {
              tryDeleteDataProduct(dataProduct.id, dataProduct.attributes.type)
              history.push('/access-hub')
            },
            setEditName,
            'API'
          )}
        />

        {activeToggle === 'connection' && (
          <Connection dataProduct={dataProduct} />
        )}
        {activeToggle === 'dataset' && <Dataset />}

        <EditName
          visible={editName}
          dataProduct={dataProduct}
          onClose={() => setEditName(false)}
          onSave={(attributes) =>
            tryUpdateDataProduct(dataProduct.id, attributes)
          }
        />
        <ManageDatasetModal type={dataProduct.attributes.type} />
      </Box>
    </Box>
  )
}

function mapStateToProps({ AppsDataProductStore }) {
  return { AppsDataProductStore }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...AlertActions,
      ...DataProductActions
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SpecificAPI))
